<template>
    <div class="log-viewer">
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="form-label fw-bold">Log File</label>
                <select class="form-select" v-model="selectedFile" @change="loadContent">
                    <option value="">-- Select a log file --</option>
                    <option v-for="file in files" :key="file.name" :value="file.name">
                        {{ file.name }} ({{ file.size }}) - {{ file.last_modified }}
                    </option>
                </select>
            </div>
            <div class="col-md-2">
                <label class="form-label fw-bold">Lines</label>
                <select class="form-select" v-model="lines" @change="loadContent">
                    <option :value="100">100</option>
                    <option :value="250">250</option>
                    <option :value="500">500</option>
                    <option :value="1000">1000</option>
                    <option :value="2000">2000</option>
                </select>
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <button class="btn btn-primary" @click="loadContent" :disabled="!selectedFile || loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Refresh
                </button>
            </div>
            <div class="col-md-4 d-flex align-items-end justify-content-end" v-if="content">
                <span class="text-muted me-3">{{ fileSize }}</span>
                <button class="btn btn-outline-secondary btn-sm me-2" @click="scrollToBottom">Scroll to bottom</button>
                <button class="btn btn-outline-secondary btn-sm" @click="scrollToTop">Scroll to top</button>
            </div>
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <div v-if="content" class="log-content-wrapper">
            <pre ref="logContent" class="log-content">{{ content }}</pre>
        </div>

        <div v-if="!selectedFile && !loading" class="text-center text-muted py-5">
            <i class="fa fa-file-alt fa-3x mb-3 d-block"></i>
            Select a log file to view its content
        </div>
    </div>
</template>

<script>
export default {
    name: 'LogViewer',
    props: {
        filesUrl: {
            type: String,
            default: '/logs/files',
        },
        contentUrl: {
            type: String,
            default: '/logs/content',
        },
    },
    data() {
        return {
            files: [],
            selectedFile: '',
            content: '',
            fileSize: '',
            lines: 500,
            loading: false,
            error: '',
        }
    },
    mounted() {
        this.loadFiles()
    },
    methods: {
        async loadFiles() {
            try {
                const { data } = await axios.get(this.filesUrl)
                this.files = data
            } catch (e) {
                this.error = 'Failed to load log files'
            }
        },
        async loadContent() {
            if (!this.selectedFile) return
            this.loading = true
            this.error = ''
            try {
                const { data } = await axios.get(this.contentUrl, {
                    params: { file: this.selectedFile, lines: this.lines },
                })
                this.content = data.content
                this.fileSize = data.size
                this.$nextTick(() => this.scrollToBottom())
            } catch (e) {
                this.error = 'Failed to load log content'
                this.content = ''
            } finally {
                this.loading = false
            }
        },
        scrollToBottom() {
            if (this.$refs.logContent) {
                this.$refs.logContent.scrollTop = this.$refs.logContent.scrollHeight
            }
        },
        scrollToTop() {
            if (this.$refs.logContent) {
                this.$refs.logContent.scrollTop = 0
            }
        },
    },
}
</script>

<style scoped>
.log-viewer {
    padding: 10px;
}
.log-content-wrapper {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
}
.log-content {
    background: #1e1e1e;
    color: #d4d4d4;
    padding: 16px;
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    max-height: 70vh;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
}
</style>
